<template>
        <v-layout column>
            <v-row 
                v-for="(tipo, index) in configuracion.tiposSolicitudes"
                :key="'tipoSolicitudes'+index"
                align="center"
                dens
                class="mt-3"
            >
                <v-col cols="4">
                    <v-text-field
                        v-model="configuracion.tiposSolicitudes[index].nombre"
                        id="tipoSolicitud"
                        :label="localization.tiposSolicitudes.nombre"
                        color="primary"
                        hide-details
                        
                        @change="updateCambiado(true)"
                    />
                </v-col>
                <v-col cols="5">
                    <v-checkbox
                        v-model="tipo.habilitar"
                        id="habilitar"
                        :label="$t('sectionConfiguracion.tiposSolicitudes.habilitar', {tipo: configuracion.tiposSolicitudes[index].nombreBase})"
                        color="primary"
                        hide-details
                        :disabled="saving || tipo.codigoTipoSolicitud === '1'"
                        @change="updateCambiado(true)"
                    />
                </v-col>
            </v-row>
        </v-layout>
</template>

<script>
export default{
    props: {
        configuracion: {
            type: Object,
            required: true
        },
        item: {
            type: Object,
            required: true
        },
        saving: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localization () {
            return this.$t('sectionConfiguracion')
        },
    },
    methods: {
        updateCambiado (val) {
            this.$emit('cambiado', val)
        }
    },
}
</script>